import clsx from 'clsx'
import React, { forwardRef } from 'react'

export interface ButtonGroupProps {
  children: React.ReactNode;
  layout?: 'horizontal' | 'vertical';
  size?: 'large' | 'small';
  align?: 'left' | 'center' | 'right';
}

type ButtonGroupContextType = {
  size?: 'large' | 'small';
  width?: 'full' | 'auto';
}

export const ButtonGroupContext = React.createContext<ButtonGroupContextType>({
  size: undefined,
  width: undefined,
})

export const ButtonGroup = forwardRef<HTMLDivElement, ButtonGroupProps>(
  (
    { children, layout = 'horizontal', align = 'right', size },
    forwardedRef
  ) => {
    const value = React.useMemo<ButtonGroupContextType>(
      () => ({
        width: layout === 'vertical' ? 'full' : 'auto',
        size,
      }),
      [layout, size, align]
    )

    return (
      <ButtonGroupContext.Provider value={value}>
        <div
          className={clsx('flex gap-2', {
            'flex-col': layout === 'vertical',
            'justify-start': layout === 'horizontal' && align === 'left',
            'justify-center': layout === 'horizontal' && align === 'center',
            'justify-end': layout === 'horizontal' && align === 'right',
          })}
          ref={forwardedRef}
        >
          {children}
        </div>
      </ButtonGroupContext.Provider>
    )
  }
)
